import type { FileUploadItemWeb } from '@gov-nx/core/hooks';

export const openAttachment = (attachment: FileUploadItemWeb) => {
	const url = URL.createObjectURL(attachment.file);
	window.open(url);
	setTimeout(() => URL.revokeObjectURL(url), 0);
};
